import { render, staticRenderFns } from "./ManageResources.vue?vue&type=template&id=5e5602ef&scoped=true&"
import script from "./ManageResources.vue?vue&type=script&lang=js&"
export * from "./ManageResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5602ef",
  null
  
)

export default component.exports